export default {
    isPersonalAuto: (lineCode) => {
        return lineCode === 'PersonalAutoLine';
    },
    isHomeOwners: (lineCode) => {
        return lineCode === 'HOPLine'
            || lineCode === 'HomeownersLine_HOE'
            || lineCode === 'HomeownersLine';
    },
    isPersonalUmbrella: (lineCode) => {
        return lineCode === 'PersonalUmbrellaLine_PUE'
            || lineCode === 'PUPLine_PUE';
    }
};
